import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import loggerMiddleware from '../middleware/logger';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import createRootReducer from '../reducers/reducers';

export const history = createBrowserHistory();

const configureStore = (preloadedState) => {
  const middlewareArray = [routerMiddleware(history), loggerMiddleware, thunkMiddleware];

  const middlewareEnhancer = applyMiddleware(...middlewareArray);

  const enhancers = [middlewareEnhancer];

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const composedEnhancers = composeEnhancers(...enhancers);

  const rootReducer = createRootReducer(history);
  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  // if not prod, reload only changed reducers
  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('../reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
};
export default configureStore;
